export default "__VITE_ASSET__CC9E9nBy__"